/* eslint-disable import/order */
import { rcaInvestigationPageEntryPoint } from '@jira/servicedesk__rca-investigation/src/rcaInvestigationPageEntryPoint.entrypoint.tsx';
import { investigationPageLoadUfo } from '@jira/servicedesk__rca-investigation/src/investigationPageLoadUfo.tsx';
import { RcaInvestigationPageSkeleton } from '@jira/servicedesk__rca-investigation/src/PageFallback.tsx';
import { rcaInvestigationResource } from '@jira/router-resources__rca-investigation/src/rcaInvestigationResource.tsx';
import { servicedeskRcaInvestigationRoute } from '@jira/router-routes__servicedesk-rca-investigation-routes/src/servicedeskRcaInvestigationRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
	getInsightResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const rcaInvestigationRoutePageEntrypoint = createPageEntryPoint({
	main: rcaInvestigationPageEntryPoint,
});

export const servicedeskRcaInvestigationRouteEntry: Route = createEntry(
	servicedeskRcaInvestigationRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		ufoName: investigationPageLoadUfo.experienceName,
		navigation: {
			menuId: MenuIdProjects,
		},
		skeleton: RcaInvestigationPageSkeleton,
		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			...getInsightResources(),
			rcaInvestigationResource,
		],
		entryPoint: () =>
			fg('aiops_rca_v2_ui') ? rcaInvestigationRoutePageEntrypoint : notFoundPageEntrypoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
